import { Component, OnInit } from '@angular/core';
import { FloatPopupService } from 'app/services/float-popup.service';
import { BoundaryGeomEditWizardComponent } from '../boundary-geom-edit-wizard.component';
import { ActivityService } from 'app/services/activity.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-boundary-geom-edit-icon',
  templateUrl: './boundary-geom-edit-icon.component.html',
  styleUrls: ['./boundary-geom-edit-icon.component.css']
})
export class BoundaryGeomEditIconComponent implements OnInit {

	constructor(
		private toastr: ToastrService,
		private activityService: ActivityService,
		private floatPopupService: FloatPopupService
	) { }

	openMapEdit() {
		if (this.activityService.editRecordListBS.getValue().ids.length) {
			this.toastr.info('Please commit or discard current changes');
			return;
		}
		this.floatPopupService.openPopup(BoundaryGeomEditWizardComponent);
	}
	ngOnInit() {
	}

}
